import { getContract, PublicClient } from 'viem';

import { getStakingPoolFactoryAddress } from 'modules/api/methods/getStakingPoolFactoryAddress';
import { memoizePromise } from 'modules/api/methods/memoizePromise';

import stakingPoolFactoryAbi from '../abi/StakingPoolFactory';

async function _getStakingPoolFactoryContract(client: PublicClient) {
  const address = await getStakingPoolFactoryAddress(client);

  return getContract({
    client,
    address,
    abi: stakingPoolFactoryAbi,
  });
}

export const getStakingPoolFactoryContract = memoizePromise(
  _getStakingPoolFactoryContract,
  client => {
    return `${client.chain?.id || 'unknown'}`;
  },
);
